export enum AppLifecycle {
    STARTING = "STARTING",
    LOGGED_OUT = "LOGGED_OUT",
    LOADING_APP = "LOADING_APP",
    READY = "READY",
}

export interface AppLifecycleInputs {
    /** True once the language is loaded and the stored session has been looked up. */
    isSessionChecked: boolean;
    isAuthenticated: boolean;
    /** Identity of the logged in user, or undefined when nobody is logged in. */
    identityKey: string | undefined;
    /**
     * Identity for which the post-login loading has finished. Comparing it with the current identity instead of
     * keeping a flag means that a render can never see a new user together with a stale "ready".
     */
    initializedFor: string | undefined;
}

export function resolveAppLifecycle(inputs: AppLifecycleInputs): AppLifecycle {
    if (!inputs.isSessionChecked) {
        return AppLifecycle.STARTING;
    }
    if (!inputs.isAuthenticated) {
        return AppLifecycle.LOGGED_OUT;
    }
    if (inputs.identityKey === undefined || inputs.initializedFor !== inputs.identityKey) {
        return AppLifecycle.LOADING_APP;
    }
    return AppLifecycle.READY;
}
